export default {
  local: () => import("./components/LocalSearchBackendProvider"),
  // remote: () => import('./search-backend-remote'),
};
